const BASE_API = process.env.MIX_ENDLESS_API_URL

const state ={
	courseFavorites:null,
}
const getters = {
	courseFavoritesGetter:({courseFavorites}) => courseFavorites,
}

const mutations = {
	setCourseFavorites : (state,payload) => state.courseFavorites = payload,
	setDeleteCourseFavorites:(state,payload) => {
		if (state.courseFavorites !== null) {
			state.courseFavorites = state.courseFavorites.filter(fav => fav.course_id !== payload);
		}
	}

}

const actions = {
	async getCourseFavorites({commit}){
		await this.$axios.get(`${BASE_API}/favorite-courses-ids`).then(res => {
			// Store the full response with favorite_id and course_id
			commit('setCourseFavorites',res.data.result)
		})
	},
	async createCourseFavorites({commit}, payload){
		const data = {
			favoritable_id: payload.course_id,
			favoritable_type: 'course'
		};
		await this.$axios.post(`${BASE_API}/favorites`, data)
	},
	async deleteCourseFavorites({commit, state}, payload){
		$('#loading').show();
		// Find the favorite_id for this course_id
		const favorite = state.courseFavorites?.find(fav => fav.course_id === payload.course_id);
		if (!favorite) {
			$('#loading').hide();
			return;
		}
		
		const data = {
			favoritable_id: payload.course_id,
			favoritable_type: 'course'
		};
		await this.$axios.delete(`${BASE_API}/favorites/${favorite.favorite_id}`, {data: data}).then(res => {
			commit('setDeleteCourseFavorites', payload.course_id)
			$('#loading').hide();
		})
	},
}

export default {namespaced:true,state,getters,mutations,actions}
